import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {Form} from "react-final-form";
import {apiGetDevice, apiPostDevice, apiPutDevice} from "./Actions";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import SwitchField from "../../../FinalForm/SwitchField";
import ApiTariffSelectField from "../../../FinalForm/api/ApiTariffSelectField";
import {useSelector} from "react-redux";
import {FiPlus, FiSave} from "react-icons/fi";
import {FilterButton, FieldArrayAddButton, FieldArrayDeleteButton} from "../components/Button";
import {FormCard} from "../components/FormCard";
import {FieldArray} from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import ModalSimple from "../components/ModalSimple";

const DeviceForm = () => {
    let {id} = useParams();

    const displayTypes = [
        {label: "ENTRY_SUCCESS", value: "ENTRY_SUCCESS"},
        {label: "EXIT_SUCCESS", value: "EXIT_SUCCESS"},
        {label: "IN_ZONE", value: "IN_ZONE"},
        {label: "NOT_IN_ZONE", value: "NOT_IN_ZONE"},
        {label: "CARD_USED", value: "CARD_USED"},
        {label: "NOT_FOUND", value: "NOT_FOUND"},
        {label: "INCORRECT_ZONE", value: "INCORRECT_ZONE"},
    ];

    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);
    let [item, setItem] = useState(null);
    let [modalRule, setModalRule] = useState(false);

    let user = useSelector((state) => state.user);
    const navigate = useNavigate();

    const deviceTypes = [
        {label: "Brána", value: -1},
        {label: "Displej", value: 1}
    ];

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetDevice(user.activeAreal.id, id, (data) => {
                setData({
                    ...data,
                    type: data.type === 0 ? -1 : data.type,
                    doDefault: data.doDefault === 0 ? -1 : data.doDefault,
                    active: data.active === 0 ? -1 : data.active
                });
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/device");
            });
        }
    };

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o zařízení.\n";
        switch (err.data) {
            case "DEVICE_NOT_FOUND": error += "Zařízení nebylo nalezeno."; break;
            case "UNKNOWN_ERROR":
            default:
                if (error.startsWith("TARIFF_")) error += "Neznámý tarif";
                else error += "Neznámá chyba.";
        }
        Toast.error(error);
    };

    const onSubmit = (values) => {
        setSaving(true);
        if (id) {
            apiPutDevice(user.activeAreal.id, id, {
                ...values,
                type: values.type === -1 ? 0 : values.type,
                doDefault: values.doDefault === -1 ? 0 : 1,
                active: values.active === -1 ? 0 : 1
            }, (data) => {
                setData({
                    ...data,
                    type: data.type === 0 ? -1 : data.type,
                    doDefault: data.doDefault === 0 ? -1 : data.doDefault,
                    active: data.active === 0 ? -1 : data.active
                });
                setSaving(false);
                Toast.success("Úspěšně uloženo.");
            }, (err) => {
                setSaving(false);
                handleError(err);
            });
        } else {
            apiPostDevice(user.activeAreal.id, {...values, type: values.type === -1 ? 0 : 1}, (data) => {
                setData({
                    ...data,
                    type: data.type === 0 ? -1 : data.type,
                    doDefault: data.doDefault === 0 ? -1 : data.doDefault,
                    active: data.active === 0 ? -1 : data.active
                });
                setSaving(false);
                navigate("/device/detail/" + data.id);
                Toast.success("Úspěšně uloženo.");
            }, (err) => {
                setSaving(false);
                handleError(err);
            });
        }
    };

    const validate = (values) => {
        const errors = {};
        errors.rules = {};
        if (values?.rules) {
            const ticketAction = values.rules?.ticketAction ?? [];
            errors.rules.ticketAction = [];
            ticketAction.forEach((ticketActionItem, index) => {
                const type = ticketActionItem?.type ?? {};
                errors.rules.ticketAction[index] = {};
                if (parseInt(type) < 0) {
                    errors.rules.ticketAction[0].type = "Vložte nezáporné číslo";
                }
            });
        }
        return errors;
    };


    return (
        <>
            <PageHeader crumbs={[{label:"Zařízení", to:"/device"}, {label: id ? "Upravit zařízení" : "Nové zařízení"}]}/>

            {loading ? <DefaultLoader text={"Načítám data zařízení..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                    mutators={{...arrayMutators}}
                    validate={validate}
                    render={({handleSubmit, values, form}) => (
                        <>
                            <FormCard>
                                <InputField label={"Název"} name={"name"} isMandatory={true} inputType={"text"}/>
                                <InputField label={"IP adresa"} name={"ipAddress"} isMandatory={true} inputType={"text"}/>
                                <SelectField name={"type"} options={deviceTypes} label={"Typ zařízení"} isMandatory={true}/>

                                {values.type === 1 ? (
                                    <div>
                                        <InputField name={"rules.basicImageUrl"} isMandatory={true} inputType={"text"} label={"Defaultní url obrázku"}/>
                                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginTop:"8px"}}>
                                            {/* Základní pravidla */}
                                            <div>
                                                <FieldArrayAddButton text={<><FiPlus size={11}/> Přidat základní pravidlo</>} onClick={() => form.mutators.push('rules.basicAction', undefined)}/>
                                                <FieldArray name="rules.basicAction">
                                                    {({fields}) => fields.map((name, index) => (
                                                        <div key={"basic_" + index} style={{border:"1px solid #e2e8f0",borderRadius:"8px",padding:"10px",marginBottom:"8px",background:"#fafafa"}}>
                                                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                                                                <span style={{fontSize: "var(--enigoo-fs-xs)",fontWeight:600,color:"#475569"}}>#{index}</span>
                                                                <FieldArrayDeleteButton onClick={() => { setModalRule(true); setItem({fields, index}); }}/>
                                                            </div>
                                                            <SelectField name={`${name}.result`} options={displayTypes} label={"Akce"} isMandatory={true}/>
                                                            <InputField name={`${name}.imageUrl`} isMandatory={true} placeholder={"url obrázku"} inputType={"text"} label={"Adresa obrázku"}/>
                                                        </div>
                                                    ))}
                                                </FieldArray>
                                            </div>
                                            {/* Vstupenkova pravidla */}
                                            <div>
                                                <FieldArrayAddButton text={<><FiPlus size={11}/> Přidat vstupenkové pravidlo</>} onClick={() => form.mutators.push('rules.ticketAction', undefined)}/>
                                                <FieldArray name="rules.ticketAction">
                                                    {({fields}) => fields.map((name, index) => (
                                                        <div key={"ticket_" + index} style={{border:"1px solid #e2e8f0",borderRadius:"8px",padding:"10px",marginBottom:"8px",background:"#fafafa"}}>
                                                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                                                                <span style={{fontSize: "var(--enigoo-fs-xs)",fontWeight:600,color:"#475569"}}>#{index}</span>
                                                                <FieldArrayDeleteButton onClick={() => { setModalRule(true); setItem({fields, index}); }}/>
                                                            </div>
                                                            <InputField inputType={"number"} name={`${name}.type`} isMandatory={true} label={"Typ vstupenky"}/>
                                                            <SelectField name={`${name}.action`} options={[
                                                                {value: "light", label: "Rozsvícení 5s"},
                                                                {value: "flash", label: "Bliknutí 4x"}
                                                            ]} label={"Akce"} isMandatory={true}/>
                                                            <InputField name={`${name}.imageUrl`} isMandatory={true} placeholder={"url obrázku"} inputType={"text"} label={"Adresa obrázku"}/>
                                                        </div>
                                                    ))}
                                                </FieldArray>
                                            </div>
                                        </div>
                                    </div>
                                ) : values.rules = null}

                                <SwitchField name={"doDefault"} label={"Vykonat i výchozí akci"} isMandatory={true} trueValue={1} falseValue={-1}/>
                                <SwitchField name={"active"}    label={"Aktivní"}               isMandatory={true} trueValue={1} falseValue={-1}/>
                                <InputField label={"Port"} name={"port"} isMandatory={false} inputType={"number"}/>
                                <ApiTariffSelectField/>
                            </FormCard>

                            {user?.user?.rights?.enigooTurniketsEdit && (
                                <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit" icon={<FiSave size={12}/>} fullWidth/>
                            )}
                        </>
                    )}
                />
            )}

            <ModalSimple
                body={"Opravdu chete smazat?"}
                title={"Vymazat pravidlo pro zařízení"}
                visible={modalRule}
                accept={() => {
                    item.fields.remove(item.index);
                    setModalRule(false);
                    setItem(null);
                }}
                close={() => {
                    setItem(null);
                    setModalRule(false);
                }}
            />
        </>
    );
};
export default DeviceForm;
